var _rect, _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoadingmanageranswer = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 76,
    width: 122,
    height: 38,
    rx: 19,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 95C190 147.467 147.467 190 95 190C42.5329 190 0 147.467 0 95C0 42.5329 42.5329 0 95 0C147.467 0 190 42.5329 190 95ZM14.25 95C14.25 139.597 50.403 175.75 95 175.75C139.597 175.75 175.75 139.597 175.75 95C175.75 50.403 139.597 14.25 95 14.25C50.403 14.25 14.25 50.403 14.25 95Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 7.125C95 3.18997 98.1945 -0.027806 102.118 0.26702C118.401 1.49037 134.136 6.89457 147.779 16.0104C163.402 26.4491 175.578 41.2861 182.769 58.6451C189.959 76.0041 191.84 95.1054 188.175 113.534C184.509 131.962 175.461 148.889 162.175 162.175C148.889 175.461 131.962 184.509 113.533 188.175C95.1053 191.84 76.0039 189.959 58.6449 182.769C41.286 175.578 26.449 163.402 16.0103 147.779C6.89449 134.136 1.49033 118.4 0.267007 102.118C-0.0278121 98.1943 3.18997 94.9998 7.125 94.9998C11.06 94.9998 14.2174 98.1961 14.5641 102.116C15.7548 115.576 20.3093 128.564 27.8588 139.862C36.7317 153.141 49.3431 163.491 64.0982 169.603C78.8533 175.715 95.0895 177.314 110.753 174.198C126.417 171.083 140.806 163.392 152.099 152.099C163.392 140.806 171.083 126.418 174.198 110.754C177.314 95.0896 175.715 78.8535 169.603 64.0984C163.492 49.3432 153.142 36.7318 139.862 27.8588C128.564 20.3094 115.576 15.7548 102.116 14.5641C98.1963 14.2174 95 11.06 95 7.125Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingmanageranswer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loadingmanageranswer.97c6df24.svg";
export { ForwardRef as ReactComponent };